// A small curated palette. Colors themselves live in App.css (with
// separate light/dark values) — this file just picks a consistent
// palette name per category so components don't need to know the theme.
const PALETTE_NAMES = ["teal", "pink", "amber", "purple", "blue", "green"];

// Simple deterministic hash so the same category always lands on the same
// color, without needing to hardcode every possible category name.
function hashString(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 4) - hash + str.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

// Returns a CSS class like "pill-teal" — see .pill-* rules in App.css.
export function getCategoryPillClass(category = "General") {
  const name = PALETTE_NAMES[hashString(category) % PALETTE_NAMES.length];
  return `pill-${name}`;
}
